export default __webpack_public_path__ + "static/media/Background_00082.fcc46607.png";